import React from "react";
import { Routes, Route } from "react-router-dom";
import FadeSlider from "../Blog/FadeSlider";
import LatestBlog from "../Blog/LatestBlog";
import CorporateWebsiteDesign2025 from "../Blog/CorporateWebsiteDesign2025";
import AReview from "../Blog/AReview";

const Blog = () => {
  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <FadeSlider />
              <LatestBlog />
            </>
          }
        />
        {/* Fix the correct path-component mapping */}
        <Route
          path="corporate-website-design-2025"
          element={<CorporateWebsiteDesign2025 />}
        />
        <Route path="areview" element={<AReview />} />
      </Routes>
    </div>
  );
};

export default Blog;
